import './footer.css';

const Footer = () => {
    const data = new Date();
    const ano = data.getFullYear();

    return (
        <footer className='footer'>
            <p>&copy; {ano} OG1 Systems</p>
        </footer>
    );
};

export default Footer;